module.exports = __webpack_public_path__ + "img/ycg_snb.a672ee44.svg";